import * as React from 'react';
import Block from "@layout/Block";
import Font from "@layout/Font";
import { PieceSyntaxHighlighter } from '@store/index';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { darcula } from 'react-syntax-highlighter/dist/styles/hljs';

interface Props {
    piece: PieceSyntaxHighlighter;
}

const SyntaxHighlighterPiece = ({ piece }: Props) => (
    <Block indent="30">
        {
            piece.title &&
            <Block indent="20">
                <div className="grid">
                    <div className="grid-6 line-bottom">
                        <Font font="primary">
                            { piece.title }
                        </Font>
                    </div>
                </div>
            </Block>
        }

        <SyntaxHighlighter language={piece.language} style={darcula}>{piece.code}</SyntaxHighlighter>
    </Block>
);

export default SyntaxHighlighterPiece;


// WEBPACK FOOTER //
// ./src/components/layout/pieces/Syntax-Highlighter/index.tsx